import {
  Component,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { MatRowDef, MatTableModule } from "@angular/material/table";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { ICreateLocationThree } from "./interfaces/create-location-three.interface";

import { LocationOneService } from "../location-one/location-one.service.service";
import { LocationTwoService } from "../location-two/location-two.service";
import { LocationThreeService } from "./location-three.service";
import LocationOneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-one/location-one.entity";
import LocationTwoAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-two/location-two.entity";
import LocationThreeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-three/location-three.entity";

import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IUpdateLocationThree } from "./interfaces/update-location-three.interface";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subject, Subscription, takeUntil } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { GeneralFiltersComponent } from "../../filters/general-filters/general-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: "app-location-three",
  templateUrl: "./location-three.component.html",
  styleUrls: ["./location-three.component.scss"],
  standalone: true,
  providers: [LocationTwoService,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    NgSelectComponent,
    FilterComponent,
    StatusFiltersComponent,
    GeneralFiltersComponent,
    HoverMenuDirective
  ],
})
export class LocationThreeComponent implements AfterViewInit, OnDestroy, OnInit {
  displayedColumns: string[] = ["nombre", "locationOne", "locationTwo", "estado", "acciones"];
  currentCreateLocation: ICreateLocationThree = this.initializeCreateLocation();
  currentUpdateLocation: LocationThreeAttributes | undefined;

  locationOneList: LocationOneAttributes[] = [];
  locationTwoList: LocationTwoAttributes[] = [];

  originalLocationTwo: LocationTwoAttributes[] = [];

  selectedLocationOneIds: string[] = [];
  selectedLocationTwoIds: string[] = [];

  filteredLocationOneList: LocationOneAttributes[] = [];
  filteredLocationTwoList: LocationTwoAttributes[] = [];

  dataSource: LocationThreeAttributes[] = [];
  private openSelect: any;
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;


  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;
  destroy$ = new Subject<void>();

  selectedStatuses: number[] = [0,1];

  locationsForm = new FormGroup({
    countryId: new FormControl('', []),
    departmentId: new FormControl<string[]>([], [])
  })
  
  constructor(
    private readonly locationOneService: LocationOneService,
    private readonly locationTwoService: LocationTwoService,
    private readonly locationThreeService: LocationThreeService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
   this.onLocationOneSelectionChange();
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.fetchAllLocations();
    this.findAllWithCount();
  }

  private initializeCreateLocation(): ICreateLocationThree {
    return { code: "", name: "", locationOneId: "", locationTwoId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }
  
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount(); 
  }

  private fetchAllLocations(): void {
    this.locationOneService.findAll()
    .pipe(
     takeUntil(this.destroy$) 
    )
    .subscribe((res) => {
      this.locationOneList = res?.data ? [...res.data] : [];
      this.filteredLocationOneList = [...this.locationOneList];
    });

    this.locationTwoService.findAll()
    .pipe(
     takeUntil(this.destroy$) 
    )
    .subscribe((res) => {
      this.locationTwoList = res?.data ? [...res.data] : [];
      this.originalLocationTwo = res?.data ? [...res.data] : [];
      this.filteredLocationTwoList = [...this.locationTwoList];
    });
  }


  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const locationOneIds = this.locationsForm.getRawValue().countryId ? [this.locationsForm.getRawValue().countryId] : [];
    const locationTwoIds = this.locationsForm.getRawValue().departmentId ? [...this.locationsForm.getRawValue().departmentId] : [];

    const locationOneCodes = this.getSelectedLocationCodes(locationOneIds, this.locationOneList);
    const locationTwoCodes = this.getSelectedLocationCodes(locationTwoIds, this.locationTwoList);

    this.locationThreeService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        locationOneCodes, 
        locationTwoCodes,
        this.selectedStatuses
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof LocationThreeAttributes {
    const validSortFields: (keyof LocationThreeAttributes)[] = ["code", "name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof LocationThreeAttributes) ? (this.sort.active as keyof LocationThreeAttributes) : "code";
  }

  private getSelectedLocationCodes(selectedIds: string[], locationList: (LocationOneAttributes | LocationTwoAttributes)[]): string[] {
    return selectedIds.map(
      (id) => locationList.find((loc) => loc._id.toString() === id)?.code || ""
    );
  }

  onLocationOneSelectionChange(): void {

    this.locationsForm.controls.countryId.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      const selectedLocationOneIds = [value];

      this.currentCreateLocation.locationTwoId = null;
      this.currentUpdateLocation?.locationTwo ? this.currentUpdateLocation.locationTwo._id = null : null;
  
      
      // Filter LocationTwo based on selected LocationOne (Country)
      if (selectedLocationOneIds.length > 0) {
        this.locationTwoList = this.originalLocationTwo.filter(
          (locationTwo) => selectedLocationOneIds.includes(locationTwo.locationOne._id.toString())
        );
      } else {
        this.locationTwoList = [...this.originalLocationTwo];
      }

      const currentLocationTwoValues = this.locationsForm.getRawValue().departmentId ? [...this.locationsForm.getRawValue().departmentId] : [];

      const removedLocationTwoValues = currentLocationTwoValues.filter((locationTwo) => {
        return this.originalLocationTwo.some((loc) => loc._id.toString() === locationTwo && selectedLocationOneIds.includes(loc.locationOne._id.toString()))
      })

      this.locationsForm.controls.departmentId.setValue(removedLocationTwoValues);

    })
  
    // Trigger change detection
    this.cdr.detectChanges();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: LocationThreeAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.locationsForm.reset();
    this.searchQuery = "";
    this.findAllWithCount();
  }

  openCreateModal(): void {
    this.currentCreateLocation = this.initializeCreateLocation();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createLocation());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(location: LocationThreeAttributes): void {
    this.currentUpdateLocation = { ...location };
    this.locationsForm.controls.countryId.setValue(this.currentUpdateLocation.locationOne._id.toString());
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateLocation(location._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createLocation(): void {
    this.locationThreeService.create(this.currentCreateLocation).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.fetchAllLocations(); 
        this.resetAllSelections();
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateLocation(id: string): void {
    if (this.currentUpdateLocation) {
      const updatedLocation: IUpdateLocationThree = {
        locationOneId: this.currentUpdateLocation.locationOne._id.toString(),
        locationTwoId: this.currentUpdateLocation.locationTwo._id.toString(),
        ...this.currentUpdateLocation
      };

      this.locationThreeService.update(id, updatedLocation).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.resetAllSelections();
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, location: LocationThreeAttributes): void {
    const originalStatusId = location.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedLocation = { ...location, statusId: updatedStatusId };

    this.locationThreeService.update(location._id.toString(), updatedLocation).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        location.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(location: LocationThreeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: location, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(location._id.toString()));
  }

  delete(id: string): void {
    this.locationThreeService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  resetAllSelections(){
    this.locationsForm.reset();
  }

  applyStatusFilter(): void {
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
